import React, { type FC, type PropsWithChildren } from 'react';

type QuoteBubbleProps = {
  /** The color of the icon. */
  color?: string;
};

const QuoteBubble: FC<PropsWithChildren<QuoteBubbleProps>> = ({ color = 'currentcolor' }) => (
  <svg fill="none" height="63" viewBox="0 0 64 63" width="64" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M9 0C4 0 0 4 0 9V41.6C0 46.5 4 50.6 9 50.6H22L29.5 60.6C30.8 62.3 33.3 62.3 34.6 60.6L42.1 50.6H55C59.9 50.6 64 46.6 64 41.6V9C64 4.1 60 0 55 0H9Z"
      fill={color}
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M23.4 24.9C23.2 24.9 23 24.9 22.8 24.9C19 25 16 22.4 16 19.2C16 16 19 13.4 22.7 13.4C25.8 13.4 28.5 15.3 29.2 17.8C29.8 19.3 30.1 21.4 29.4 24.6C28.5 28.1 25.7 32.4 20.2 36.2C20 36.4 19.6 36.3 19.4 36.2L17.6 34.6C17.3 34.3 17.3 33.8 17.7 33.5C19.9 32 23.2 28.9 23.4 24.9Z"
      fill="white"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M41.9 24.9C41.7 24.9 41.5 24.9 41.3 24.9C37.6 24.9 34.6 22.3 34.6 19.1C34.6 15.9 37.6 13.3 41.3 13.3C44.4 13.3 47.1 15.2 47.8 17.7C48.4 19.2 48.7 21.3 48 24.5C47.1 28 44.3 32.3 38.8 36.1C38.6 36.3 38.2 36.2 38 36.1L36.2 34.5C35.9 34.2 35.9 33.7 36.3 33.4C38.5 32 41.8 28.9 41.9 24.9Z"
      fill="white"
      fillRule="evenodd"
    />
  </svg>
);

export default QuoteBubble;
